import { Injectable } from '@angular/core';

import {HttpParams, HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {emptyRdfServiceResponseError, IRdfServiceResponseError, Method} from "./response-interfaces";
import {Observable} from "rxjs";


@Injectable()
export class ApiService {

  constructor(private http: HttpClient) { }

  // Returns observable of js object
  get(url: string, headers: object, params?: object): Observable<Object> {

    let requestHeaders = new HttpHeaders();
    for (const key of Object.keys(headers)) {
      requestHeaders = requestHeaders.set(key, headers[key] + '');
    }
    // requestHeaders = requestHeaders.set('Access-Control-Allow-Origin', '*');
    let requestParams = new HttpParams();
    if (params) {
      for (const key of Object.keys(params)) {
        requestParams = requestParams.set(key, params[key]);
      }
    }

    return this.http.get(url, { headers: requestHeaders, params: requestParams });
  }


  getString(url: string, headers: object, params?: object): Observable<HttpResponse<string>> {

    let requestHeaders = new HttpHeaders();
    for (const key of Object.keys(headers)) {
      requestHeaders = requestHeaders.set(key, headers[key] + '');
    }
    // requestHeaders = requestHeaders.set('Access-Control-Allow-Origin', '*');
    let requestParams = new HttpParams();
    if (params) {
      for (const key of Object.keys(params)) {
        requestParams = requestParams.set(key, params[key]);
      }
    }

    return this.http.get(url, { headers: requestHeaders, params: requestParams,  observe: 'response', responseType: 'text',reportProgress: true});
  }
  post(url: string, headers: object, body: string, params?: object): Observable<Object> {

    let requestHeaders = new HttpHeaders();
    for (const key of Object.keys(headers)) {
      requestHeaders = requestHeaders.set(key, headers[key] + '');
    }

    let requestParams = new HttpParams();
    if (params) {
      for (const key of Object.keys(params)) {
        requestParams = requestParams.set(key, params[key]);
      }
    }

    return this.http.post(url, body, { headers: requestHeaders, params: requestParams });
  }

  put(url: string, headers: object, body, params?: object): Observable<Object> {

    let requestHeaders = new HttpHeaders();
    for (const key of Object.keys(headers)) {
      requestHeaders = requestHeaders.set(key, headers[key] + '');
    }

    let requestParams = new HttpParams();
    if (params) {
      for (const key of Object.keys(params)) {
        requestParams = requestParams.set(key, params[key]);
      }
    }

    return this.http.put(url, body, { headers: requestHeaders, params: requestParams });
  }
  patch(url: string, headers: object, body: string, params?: object): Observable<Object> {

    let requestHeaders = new HttpHeaders();
    for (const key of Object.keys(headers)) {
      requestHeaders = requestHeaders.set(key, headers[key] + '');
    }

    let requestParams = new HttpParams();
    if (params) {
      for (const key of Object.keys(params)) {
        requestParams = requestParams.set(key, params[key]);
      }
    }

    return this.http.patch(url, body, { headers: requestHeaders, params: requestParams });
  }

  delete(url: string, headers: object, body: string, params?: object): Observable<Object> {

    let requestHeaders = new HttpHeaders();
    for (const key of Object.keys(headers)) {
      requestHeaders = requestHeaders.set(key, headers[key] + '');
    }
    // requestHeaders = requestHeaders.set('Access-Control-Allow-Origin', '*');
    let requestParams = new HttpParams();
    if (params) {
      for (const key of Object.keys(params)) {
        requestParams = requestParams.set(key, params[key]);
      }
    }

    return this.http.delete(url,  { headers: requestHeaders, params: requestParams });
  }

  // Returns observable of string
  getAsString(url: string, headers?: object, params?: object): Observable<string> {
    let requestParams = new HttpParams();

    let requestHeaders = new HttpHeaders();
    if (headers) {
      for (const key of Object.keys(headers)) {
        requestHeaders = requestHeaders.set(key, headers[key] + '');
      }
    }

    if (params) {
      for (const key of Object.keys(params)) {
        requestParams = requestParams.set(key, params[key]);
      }
    }

    return this.http.get(url, {
      headers: requestHeaders,
      params: requestParams,
      responseType: 'text'
    });
  }

  /**
   * Конвертирует http error в структуру IRdfServiceResponseError
   * @param method метод - GET PUT POST DELETE
   * @param error ошибка из http
   * @param url url запроса
   * @param headerRequest header запроса
   * @param body тело запроса. Применимо для PUT POST
   */
   mapHttpErrorToRdfError(method: Method, error,  url?: string, headerRequest?: object, body?: object): IRdfServiceResponseError {
    const err: IRdfServiceResponseError = {
      ...emptyRdfServiceResponseError,
      method: method,
      errorCode: error.status,
      rdfErrorCode: error.error && error.error['Code']?error.error['Code']:'',
      msg: error.message,
      rdfMsg: error.error && error.error['Msg']?error.error['Msg']:'',
      isHttpError: true,
      url: url,
      requestParams: headerRequest,
      requestBody: body,
      response: (error['error']) ? error['error'] : null
    };
    return err;
  }

  saveCsv(fileName: string, body: string) {
    const blob = new Blob([body], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // Browsers that support HTML5 download attribute
        const url1 = URL.createObjectURL(blob);
        link.setAttribute('href', url1);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

}
